
export class CommonEnums {
  static community_list = ["BC",
    "BC Muslim",
    "BCM",
    "CHRISTIAN",
    "DNC",
    "FC",
    "ILLATHU PILLAIMAR(BC)",
    "MARAVAR (DNC)",
    "MBC",
    "MBC/DNC",
    "OC",
    "SC",
    "SC/ST",
    "SCA",
    "ST"];

  //['BC', 'BCM', 'MBC', 'DNC', 'SC', 'SCA', 'ST', 'OC'];
  static country_list = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Côte d\'Ivoire', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo (Congo-Brazzaville)', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czechia (Czech Republic)', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini (fmr. "Swaziland")', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Holy See', 'Honduras', 'Hungary', 'Iceland', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar (formerly Burma)', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine State', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'];
  static india_states = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'];
  static cites_in_tamil_nadu = ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Tiruppur', 'Salem', 'Erode', 'Tirunelveli', 'Vellore', 'Thoothukkudi', 'Dindigul', 'Thanjavur', 'Ranipet', 'Sivakasi', 'Karur', 'Udhagamandalam', 'Hosur', 'Nagercoil', 'Kancheepuram', 'Kumarapalayam', 'Karaikkudi', 'Neyveli', 'Cuddalore', 'Kumbakonam', 'Tiruvannamalai', 'Pollachi', 'Rajapalayam', 'Gudiyatham', 'Pudukkottai', 'Vaniyambadi', 'Ambur', 'Nagapattinam'];
  static districts_in_tamil_nadu = ['Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri', 'Dindigul', 'Erode', 'Kallakurichi', 'Kanchipuram', 'Kanyakumari', 'Karur', 'Krishnagiri', 'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 'Perambalur', 'Pudukkottai', 'Ramanathapuram', 'Ranipet', 'Salem', 'Sivagangai', 'Tenkasi', 'Thanjavur', 'Theni', 'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 'Tirupattur', 'Tiruppur', 'Tiruvallur', 'Tiruvannamalai', 'Tiruvarur', 'Vellore', 'Viluppuram', 'Virudhunagar'];
  static blood_groups = [
    {
      id: 'A POSITIVE',
      text: 'A Positive'
    },
    {
      id: 'A NEGATIVE',
      text: 'A Negative'
    },
    {
      id: 'A1 POSITIVE',
      text: 'A1 positive'
    },
    {
      id: 'A1 NEGATIVE',
      text: 'A1 positive'
    },
    {
      id: 'A2 POSITIVE',
      text: 'A2 positive'
    },
    {
      id: 'A2 NEGATIVE',
      text: 'A2 positive'
    },
    {
      id: 'A1B POSITIVE',
      text: 'A1B positive'
    },
    {
      id: 'A1B NEGATIVE',
      text: 'A1B positive'
    },
    {
      id: 'A2B POSITIVE',
      text: 'A2B positive'
    },
    {
      id: 'A2B NEGATIVE',
      text: 'A2B positive'
    },
    {
      id: 'B POSITIVE',
      text: 'B positive'
    },
    {
      id: 'B NEGATIVE',
      text: 'B positive'
    },
    {
      id: 'AB POSITIVE',
      text: 'AB positive'
    },
    {
      id: 'AB NEGATIVE',
      text: 'AB positive'
    },
    {
      id: 'O POSITIVE',
      text: 'O positive'
    },
    {
      id: 'O NEGATIVE',
      text: 'O positive'
    }];
  static religions = [
    {
      id: 'HINDU',
      text: 'Hindu'
    },
    {
      id: 'CHRISTIAN',
      text: 'Christian'
    },
    {
      id: 'MUSLIM',
      text: 'Muslim'
    },
    {
      id: 'BUDDHIST',
      text: 'Buddhist'
    },
    {
      id: 'JAINIS',
      text: 'Jainis'
    },
    {
      id: 'SIKHS',
      text: 'Sikhs'
    }];
  static relationship_names = [
    'Father', 'Mother', 'Grand Father', 'Grand Mother', 'Sister', 'Brother', 'Uncle', 'Aunty', 'Husband', 'Wife', 'Others'
  ];
  static accadamic_types = ['SSLC', 'HSC', 'DEGREE'];
  static sslc_syllabus_types = ['STATE_BOARD', 'CBSE', 'ICSE'];
  static syllabus_types = ['STATE_BOARD', 'CBSE', 'ICSE']; // ,'ISC or Equvalent'
  static language1_subjects = ['TAMIL', 'HINDI', 'SANSKRIT', 'FRENCH'];
  static cbsc_subject_types = ['LANGUAGE I', 'LANGUAGE II', 'THEORY', 'PRACTICAL'];
  static icse_subject_types = ['LANGUAGE', 'THEORY', 'PRACTICAL'];
  static months = [
    {
      id: '1',
      text: 'January'
    },
    {
      id: '2',
      text: 'February'
    },
    {
      id: '3',
      text: 'March'
    },
    {
      id: '4',
      text: 'April'
    },
    {
      id: '5',
      text: 'May'
    },
    {
      id: '6',
      text: 'June'
    },
    {
      id: '7',
      text: 'July'
    },
    {
      id: '8',
      text: 'August'
    },
    {
      id: '9',
      text: 'September'
    },
    {
      id: '10',
      text: 'October'
    },
    {
      id: '11',
      text: 'November'
    },
    {
      id: '12',
      text: 'December'
    }
  ];

  static days = [
    {
      id: 0,
      string_id: 'SUNDAY',
      text: 'Sunday'
    },
    {
      id: 1,
      string_id: 'MONDAY',
      text: 'Monday'
    },
    {
      id: 2,
      string_id: 'TUESDAY',
      text: 'Tuesday'
    },
    {
      id: 3,
      string_id: 'WEDNESDAY',
      text: "Wednesday"
    },
    {
      id: 4,
      string_id: 'THURSDAY',
      text: "Thursday"
    },
    {
      id: 5,
      string_id: 'FRIDAY',
      text: "Friday"
    },
    {
      id: 6,
      string_id: 'SATURDAY',
      text: "Saturday"
    }

  ];


  static genders = [
    {
      id: 'male', text: 'Male'
    },
    {
      id: 'female', text: 'Female'
    },
    {
      id: 'transgender', text: 'Transgender'
    }
  ];

  static date_time_format = 'dd/MM/yyyy, h:mm a';
  static date_format = 'dd/MM/yyyy';
  static time_format = 'h:mm a';

  static finance_types = [{ id: 'regular', text: 'AIDED' }, { id: 'self_finance', text: 'SELF FINANCE' }];
  static programme_categories = [
    { id: 'all', text: 'ALL' },
    { id: 'life_science', text: 'LIFE SCIENCE' },
    { id: 'commerce', text: 'COMMERCE' },
    { id: 'computer', text: 'COMPUTER' }
  ];

  static college_cells = [
    { programme_id: 'national_cadet_corps', display_name: 'NATIONAL CADET CORPS' },
    { programme_id: 'national_service_scheme', display_name: 'NATIONAL SERVICE SCHEME' },
    { programme_id: 'red_ribbon_club', display_name: 'RED RIBBON CLUB' },
    { programme_id: 'citizen_consumer_club', display_name: 'CITIZEN CONSUMER CLUB' },
    { programme_id: 'health_and_fitness_club', display_name: 'HEALTH AND FITNESS CLUB' },
    { programme_id: 'grand_parent_students_club', display_name: 'GRAND PARENT STUDENTS CLUB' },
    { programme_id: 'exnora', display_name: 'EXNORA' },
  ];

  static parts = {
    ug: [
      { id: 'PART_I', text: 'PART I', allow_multi_course: true },
      { id: 'PART_II', text: 'PART II' },
      {
        id: 'PART_III', text: 'PART III',
        course_types: [
          { id: 'CORE', text: 'CORE' },
          { id: 'ALLIED', text: 'ALLIED' },
          { id: 'ALLIED_PRACTICAL', text: 'ALLIED PRACTICAL' },
          { id: 'ELECTIVE', text: 'ELECTIVE' },
          { id: 'CORE_SPECIAL_THEORY', text: 'CORE SPECIAL THEORY' },
          { id: 'CORE_SPECIAL_PROJECT', text: 'CORE SPECIAL PROJECT' },
          { id: 'PRACTICAL', text: 'PRACTICAL' },
          { id: 'COMPREHENSION_VIVA', text: 'COMPREHENSION VIVA' },
          { id: 'INTERNSHIP', text: 'INTERNSHIP' },
          { id: 'PROJECT_VIVA', text: 'PROJECT VIVA' },
          { id: 'GENERIC_ELECTIVE_THEORY', text: "Generic Elective - Theory" },
          { id: 'GENERIC_ELECTIVE_PRACTICAL', text: "Generic Elective - Practical" },
          { id: 'CORE_BASED_ELECTIVE', text: "Core Based Elective" },
        ]
      },
      {
        id: 'PART_IV', text: 'PART IV', allow_multi_course: true,
        course_types: [
          { id: 'SKILL_BASED_MANDATORY', text: 'SKILL BASED MANDATORY' },
          { id: 'SKILL_BASED_MANDATORY_I', text: 'SKILL BASED MANDATORY - I' },
          { id: 'SKILL_BASED_MANDATORY_II', text: 'SKILL BASED MANDATORY - II' },
          { id: 'SKILL_BASED_MANDATORY_III', text: 'SKILL BASED MANDATORY - III' },
          { id: 'SKILL_BASED_MANDATORY_IV', text: 'SKILL BASED MANDATORY - IV' },
          { id: 'SKILL_BASED_MANDATORY_IV_V', text: 'SKILL BASED MANDATORY - IV & V' },
          { id: 'SKILL_BASED_MANDATORY_VI', text: 'SKILL BASED MANDATORY - VI' },
          { id: 'SKILL_BASED_MANDATORY_VII', text: 'SKILL BASED MANDATORY - VII' },
          { id: 'NON_MAJOR_ELECTIVE', text: 'NON MAJOR ELECTIVES' },
          { id: 'ONLINE_NON_MAJOR_ELECTIVES', text: 'ONLINE NON MAJOR ELECTIVES' },
          { id: 'SKILL_BASED_ELECTIVE', text: 'SKILL BASED ELECTIVE' },
          { id: "FOUNDATION_COURSE", "text": "Foundation Course" },
          { id: "SKILL_ENHANCEMENT_COURSE_ENTREPRENEURIAL_BASED", "text": "Skill Enhancement Course(Entrepreneurial Based)" },
          { id: "SKILL_ENHANCEMENT_COURSE_GENERIC_ELECTIVE", "text": "Skill Enhancement Course(Generic Elective)" },
          { id: "SKILL_ENHANCEMENT_COURSE_NON_MAJOR_ELECTIVE", "text": "Skill Enhancement Course(Non Major Elective)" },
          { id: "SKILL_ENHANCEMENT_COURSE_DISCIPLINE_SPECIFIC", "text": "Skill Enhancement Course(Discipline Specific)" },
          { id: "SKILL_ENHANCEMENT_COURSE", "text": "Skill Enhancement Course" },
          { id: "ABILITY_ENHANCEMENT_COMPULSORY_COURSE", "text": "Ability Enhancement Compulsory Course" },
          { id: "ENVIRONMENTAL_STUDIES", "text": "Environmental Studies" },
          { id: "VALUE_EDUCATION_PROFESSIONAL_ETHICS_HUMAN_RIGHTS_AND_WOMEN_STUDIES", "text": "Value Education, Professional Ethics, Human Rights and Women Studies" },
          { id: "INTERNSHIP", "text": "Internship" },
          { id: "PROFESSIONAL_COMPETENCY_SKILL_ENHANCEMENT_COURSE", "text": "Professional Competency Skill Enhancement Course" },
          { id: "PHYSICAL_EDUCATION_PRACTICAL", "text": "Physical Education Practical" },
        ]
      },
      { id: 'PART_V', text: 'PART V', allow_multi_course: true }
    ],
    pg: [
      {
        id: 'CORE', text: 'CORE',
        course_types: [
          { id: 'THEORY', text: 'THEORY' },
          { id: 'PRACTICAL', text: 'PRACTICAL' },
          { id: 'VIVA', text: 'VIVA' },
          { id: 'INTERNSHIP', text: 'INTERNSHIP' },
        ]
      },
      {
        id: 'ELECTIVE', text: 'ELECTIVE',
        course_types: [
          { id: 'SUBJECT_BASED', text: 'SUBJECT BASED' },
          { id: 'NON_MAJOR_ELECTIVE_COURSE', text: 'NON-MAJOR ELECTIVE COURSE' },
          { id: 'INTERDISCIPLINARY_ELECTIVE_COURSE', text: 'INTERDISCIPLINARY ELECTIVE COURSE' }
        ]
      },
      {
        id: 'SUPPORTIVE_COURSES', text: 'SUPPORTIVE COURSES',
        course_types: [
          { id: 'SUPPORTIVE_COURSES_1', text: 'SUPPORTIVE COURSES I' },
          { id: 'SUPPORTIVE_COURSES_2', text: 'SUPPORTIVE COURSES II' },
          { id: 'SKILL_ENHANCEMENT_COURSE', text: 'Skill Enhancement Course' },
          { id: 'ABILITY_ENHANCEMENT_COMPULSORY_COURSE', text: 'Ability Enhancement Compulsory Course' },
          { id: 'PROFESSIONAL_COMPETENCY_SKILL_ENHANCEMENT ', text: 'Professional Competency Skill enhancement' },
          { id: 'SOCIAL_SERVICE ', text: 'Social Service' }

        ]
      },
      {
        id: 'SELF_LEARNING', text: 'SELF LEARNING',
        course_types: [
          { id: 'EXTRA_OPTIONAL_CREDIT_COURSE', text: 'EXTRA OPTIONAL CREDIT COURSE' }
        ]
      }
    ]


  };

  static rommon_letters: any = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
    5: 'V',
    6: 'VI',
    7: 'VII',
    8: 'VIII',
    9: 'IX',
    10: 'X',
    'I': 'I',
    'II': 'II',
    'III': 'III',
    'IV': 'IV',
    'V': 'V',
    'VI': 'VI',
    'VII': 'VII',
    'VIII': 'VIII',
    'IX': 'IX',
    'X': 'X',
  };

  static roman_letters: any = {
    1: 'I',
    2: 'II',
    3: 'III',
    4: 'IV',
    5: 'V',
    6: 'VI',
    7: 'VII',
    8: 'VIII',
    9: 'IX',
    10: 'X',
    11: 'XI',
    12: 'XII',
    13: 'XIII',
    14: 'XIV',
    15: 'XV',
    16: 'XVI',
    17: 'XVII',
    18: 'XVIII',
    19: 'XIX',
    20: 'XX',
    21: 'XXI',
    22: 'XXII',
    23: 'XXIII',
    24: 'XXIV',
    25: 'XXV',
    26: 'XXVI',
    27: 'XXVII',
    28: 'XXVIII',
    29: 'XXIX',
    30: 'XXX',
    31: 'XXXI',
    32: 'XXXII',
    33: 'XXXIII',
    34: 'XXXIV',
    35: 'XXXV',
    36: 'XXXVI',
    37: 'XXXVII',
    38: 'XXXVIII',
    39: 'XXXIX',
    40: 'XL',
    41: 'XLI',
    42: 'XLII',
    43: 'XLIII',
    44: 'XLIV',
    45: 'XLV',
    46: 'XLVI',
    47: 'XLVII',
    48: 'XLVIII',
    49: 'XLIX',
    50: 'L'
  };

  static component_types = [
    { id: 'INTERNAL_EXAM', text: 'INTERNAL EXAM' },
    { id: 'QUIZ', text: 'QUIZ' },
    { id: 'ASSIGNMENT', text: 'ASSIGNMENT' },
    { id: 'MODEL_EXAM', text: 'MODEL EXAM' },
    { id: 'COMPOSITION_EXAM', text: 'COMPOSITION EXAM' },
    { id: 'SEMINAR', text: 'SEMINAR' },
    { id: 'PRACTICAL', text: 'PRACTICAL' },
    { id: 'PROJECT', text: 'PROJECT' },
    { id: 'THEORY', text: 'THEORY' },
    { id: 'INTERNSHIP', text: 'INTERNSHIP' },
    { id: 'TERMINAL_EXAM', text: 'TERMINAL EXAM' },
  ];
  static terms = [
    { id: 'I', text: 'I' },
    { id: 'II', text: 'II' },
    { id: 'III', text: 'III' },
    { id: 'IV', text: 'IV' },
    { id: 'V', text: 'V' },
    { id: 'VI', text: 'VI' },
  ];

  static obe_calculation_list = [
    { id: 'BEST_TWO', text: 'BEST TWO' },
    { id: 'BEST_ONE', text: 'BEST ONE' },
    { id: 'AVG', text: 'AVERAGE' },
    { id: 'SINGLE', text: 'SINGLE' }
  ];

  static getParts(programme_type_id: string): any[] {
    if (programme_type_id.toLowerCase() === 'ug') {
      return this.parts.ug;
    } else if (programme_type_id.toLowerCase() === 'pg') {
      return this.parts.pg;
    } else {
      return [{ id: 'none', text: 'NONE' }];
    }
  }

  static getCoursePartType(programme_type_id: string, part: string): any[] | undefined {
    if (programme_type_id.toLowerCase() === 'ug') {
      const part_obj = this.parts.ug.find(c => c.id === part);
      if (part_obj && part_obj.course_types && part_obj.course_types.length > 0) {
        return part_obj.course_types;
      }
    } else if (programme_type_id.toLowerCase() === 'pg') {
      const part_obj = this.parts.pg.find(c => c.id === part);
      if (part_obj && part_obj.course_types && part_obj.course_types.length > 0) {
        return part_obj.course_types;
      }
    }
    return undefined;
  }


  static getLastNYears(last_n: number = 10, year: number = 0): number[] {
    let start_year = new Date().getFullYear();
    if (year > 0) {
      start_year = year;
    }
    let r_year = start_year - year;
    if (r_year > last_n) {
      r_year = last_n;
    }
    const years: number[] = [];
    for (let index = 0; index < last_n; index++) {
      years.push(start_year - index);
    }

    return years;

  }

  static getNEnrolledYears(last_n: number = 5, next_n: number = 5, year: number = 0): number[] {
    let start_year = new Date().getFullYear();
    if (year > 0) {
      start_year = year;
    }
    let r_year = start_year - year;
    if (r_year > last_n) {
      r_year = last_n;
    }
    const years: number[] = [];
    for (let index = 0; index < last_n; index++) {
      years.push(start_year - index);
    }

    let upcoming_years: number[] = [];
    for (let i = 1; i <= next_n; i++) {
      upcoming_years.push(start_year + i)
    }

    let all_years: number[] = [];
    all_years = upcoming_years.reverse();
    all_years = all_years.concat(years);
    return all_years;
  }

  static getNextNYears(next_n: number = 5) {
    let start_year = new Date().getFullYear();
    let upcoming_years: number[] = [];
    for (let i = 0; i <= next_n; i++) {
      upcoming_years.push(start_year + i)
    }
    return upcoming_years;
  }

  static getNexNYears(year: number = 0): number[] {
    let end_year = new Date().getFullYear();

    const years: number[] = [];
    for (let index = year; index <= end_year; index++) {
      years.push(index);
    }

    return years;

  }

  static getAcademicYears(list_n: number = 10, year: number = 0): number[] {
    let start_year = new Date().getFullYear() + 3;
    if (year > 0) {
      start_year = year;
    }
    let r_year = start_year - year;
    if (r_year > list_n) {
      r_year = list_n;
    }
    const years: number[] = [];
    for (let index = 0; index < list_n; index++) {
      years.push(start_year - index);
    }

    return years;

  }


  static getSemesterList(no_of_semesters: number): any[] {
    const val: any[] = [];
    for (let index = 0; index < no_of_semesters; index++) {
      const sem = (index + 1);
      val.push({ id: sem, text: 'SEMESTER ' + this.rommon_letters[sem] });
    }
    return val;
  }

  static getCOIDs(no_of_cos: number = 5): any[] {
    const val: any[] = [];
    for (let index = 0; index < no_of_cos; index++) {
      const sem = (index + 1);
      val.push({ id: sem, text: 'CO ' + this.rommon_letters[sem] });
    }
    return val;
  }

  static numberToCOs(co_ids: any[]): any[] {
    const val: any[] = [];
    for (const elem of co_ids) {
      val.push('CO ' + this.rommon_letters[elem]);
    }
    return val;
  }

  static getFinanceDisplayText(finance_type: string): string {
    if (finance_type === 'self_finance') {
      return 'Self Finance';
    } else if (finance_type === 'regular') {
      return 'Aided';
    }
    return '';
  }

  static getNumbers(to: number = 10): number[] {
    const numbers_to_send: number[] = [];
    for (let index = 0; index < to; index++) {
      numbers_to_send.push(index + 1);
    }
    return numbers_to_send;
  }

  static getClassName(enrolment_year: number, programme_name?: string, section?: string, programme_type_id?: string) {
    var diff = Math.ceil(((new Date().getMonth() - 5) + (12 * (new Date().getFullYear() - enrolment_year))) / 12);
    var class_string: string = "", programme: string = "", sec: string = "";
    if (!programme_type_id) {
      if (diff == 1)
        class_string = "I";
      else if (diff == 2)
        class_string = "II";
      else if (diff == 3)
        class_string = "III"
      else
        class_string = enrolment_year.toString();
    }

    if (programme_type_id) {
      if (programme_type_id == 'UG') {
        if (diff == 1)
          class_string = "I";
        else if (diff == 2)
          class_string = "II";
        else if (diff == 3)
          class_string = "III"
        else
          class_string = enrolment_year.toString();
      }
      else {
        if (diff == 1)
          class_string = "I";
        else if (diff == 2)
          class_string = "II";
        else
          class_string = enrolment_year.toString();
      }
    }

    if (programme_name == undefined || programme_name == '' || programme_name == " " || programme_name == null) {
      programme = '';
    }
    else {
      programme = programme_name
    }
    if (section == undefined || section == '' || section == " " || section == null) {
      sec = '';
    }
    else {
      sec = section;
    }
    return class_string + " " + programme + " " + sec;
  }

  static getAcademicYear(): string {
    var date = new Date();
    if (date.getMonth() + 1 >= 6) {
      return date.getFullYear() + "-" + (date.getFullYear() + 1)
    }
    return date.getFullYear() - 1 + "-" + date.getFullYear();
  }

  static getAcademicYearUsingEnrolledYear(enrolled_year: number, programme_type_id: string) {
    if(programme_type_id == 'UG') {
      return `${enrolled_year} - ${enrolled_year + 3}`;
    } else if(programme_type_id == 'PG') {
      return `${enrolled_year} - ${enrolled_year + 2}`;
    } else {
      return enrolled_year;
    }
  }
}
